import type { PublishStatus } from '../models/Place.ts';

interface PublishStatusInfo {
  label: string; // 中文顯示
  color: string; // 對應顏色
}

const publishStatusMap: Record<PublishStatus, PublishStatusInfo> = {
  PUBLISHED: { label: '已上架', color: '#12B886' },
  PENDING: { label: '待上架', color: '#FAB005' },
  UNPUBLISHED: { label: '已下架', color: '#FA5252' },
};

export const getPublishStatusLabel = (publishStatus: PublishStatus): string => {
  return publishStatusMap[publishStatus]?.label || publishStatus;
};

export const getPublishStatusColor = (publishStatus: PublishStatus): string => {
  return publishStatusMap[publishStatus]?.color || 'gray';
};
